import React from 'react';
import { RouteComponentProps } from 'react-router';

import ExternalDashboardLayout from './ExternalDashboardLayout';

const withExternalDashboard = <P extends object>(
  Component: React.ComponentType<P>
) => {
  type Props = P & RouteComponentProps<{ companyId?: string }>;

  class Dashboard extends React.Component<Props> {
    render() {
      return (
        <ExternalDashboardLayout>
          <Component {...this.props} />
        </ExternalDashboardLayout>
      );
    }
  }

  return Dashboard;
};
export default withExternalDashboard;
